import React from 'react';

function Fields(props) {
    return (
        <>
            <p className="light-gray">{props.heading || ''}</p>
            <p
                className={props.className}
                id={props.id}
            >{props.value || ''}
            </p>
        </>
    );
}

export default (Fields);
